export const NAME = 'session';
export const SESSION_KEY = 'session';
